"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotAlertCircle = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotAlertCircle = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#AlertCircle_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M4.434 20c0-8.598 6.97-15.568 15.567-15.568 8.597 0 15.567 6.97 15.567 15.567 0 8.597-6.97 15.567-15.567 15.567-8.597 0-15.567-6.97-15.567-15.567ZM20.001 2.231C10.189 2.232 2.234 10.187 2.234 20s7.955 17.767 17.767 17.767 17.767-7.955 17.767-17.767S29.813 2.232 20 2.232ZM21.102 28a1.1 1.1 0 0 0-2.2 0v.01a1.1 1.1 0 1 0 2.2 0v-.01Zm-1.101-17c-1.668 0-2.504 1.626-2.5 3.25v.04c.003 1.712.018 9.71 2.5 9.71 2.5 0 2.503-8.124 2.5-9.75-.004-1.624-.833-3.25-2.5-3.25Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "AlertCircle_svg__a"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};
exports.SpotAlertCircle = SpotAlertCircle;
SpotAlertCircle.displayName = "SpotAlertCircle";